import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";
import { VirtualTimeScheduler } from 'rxjs';

@Component({
	selector: 'unos-izmjena-dom',
	templateUrl: './unos-izmjena-dom.component.html',
	styleUrls: ['./unos-izmjena-dom.component.css']
})
export class UnosIzmjenaDomComponent implements OnInit {

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }

	@Input() id;
	@Input() novi;
	@Input() idTipaPrijave;
	@Input() prekoPortala;
	@Input() nazivKategorije;

	@Output() onInsertDom = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();
	@Output() checkDomDealine = new EventEmitter<any>();

	prijavadom : any = {'id' : '', 'idTipaPrijave' : '', 'idDoma' : '', 'jmbg' : '', 'ime' : '', 'prezime' : '', 'opstina' : '', 'adresa' : '', 'telefon' : '', 'email' : '', 
	'datumRodjenja' : '', 'mjestoRodjenja' : '', 'pol' : '', 'imeOca' : '', 'imeMajke' : '', 'prekoPortala' : '', 'userId' : '', 'drzavljanstvo' : '', 
	'opstinaWarning' : '', 'idUstanove' : '', 'idRazreda' : '', 'nazivUstanove' : '', 'nazivRazreda' : '', 
	'domovi' : [], 'kategorije' : [], 'srednjeSkole' : [], 'takmicenja' : [], 
	'srOcjena8' : '', 'srOcjena9' : '', 'srOcjenaPrethodni' : '', 'bodoviTakmicenje' : '', 'bodoviDisciplina' : '', 
	'srOcjenaPretPrethodni' : '','ocjenaExt' : '', 'luca' : '', 'porodicniStatus' : '', 'korisnikMaterijalno' : '',  
	'idFakulteta' : '', 'godina' : '', 'nivoStudija' : '', 'indexUspjesnosti' : '', 'brojETCS' : '', 'redniBrojUpisaGod' : '', 'rePopulacija' : '', 'studSaInvalid' : '', 
	'idStatusa' : '', 'idJedinice' : ''};

	err_jmbg = false;
	err_jmbg_poruka = '';
	err_ime = false;
	err_ime_poruka = '';
	err_prezime = false;
	err_prezime_poruka = '';	
	err_opstina = false;
	err_opstina_poruka = '';
	err_adresa = false;
	err_adresa_poruka = '';
	err_datumRodjenja = false;
	err_datumRodjenja_poruka = '';
	err_mjestoRodjenja = false;
	err_mjestoRodjenja_poruka = '';
	err_drzavljanstvo = false;
	err_drzavljanstvo_poruka = '';
	err_pol = false;
	err_pol_poruka = '';
	err_imeOca = false;
	err_imeOca_poruka = '';
	err_imeMajke = false;
	err_imeMajke_poruka = '';
	err_dom_poruka = '';
	err_dom = false; 
	err_srocjena8 = false;
	err_srocjena8_poruka = '';
	err_srocjena9 = false;
	err_srocjena9_poruka = '';
	err_srocjenapret = false;
	err_srocjenapret_poruka = '';
	err_idUstanove = false;
	err_idUstanove_poruka = '';
	err_idRazreda = false;
	err_idRazreda_poruka = '';
	err_drzava = false;
	err_drzava_poruka = '';
	err_srocjenapretpret = false; 
	err_srocjenapretpret_poruka = '';
	err_ocjenaext = false;
	err_ocjenaext_poruka = ''; 
	err_idFakulteta = false;
	err_idFakulteta_poruka = ''; 
	err_godina = false;
	err_godina_poruka = ''; 
	err_nivoStudija = false;
	err_nivoStudija_poruka = '';
	err_telefon = false;
	err_telefon_poruka = '';
	err_brojETCS = false;
	err_brojETCS_poruka = '';
	err_indexUspjesnosti = false;
	err_indexUspjesnosti_poruka = '';
	err_redniBrojUpisaGod = false;
	err_redniBrojUpisaGod_poruka = '';

	saveDisabled = false;
	loading = false;
	msg : any;
	stepen : any = null;

	domovi : any = [];
	kategorije : any = [];
	takmicenja : any = [];
	opstine : any = [];
	drzavljanstva : any = [];
	srednjeSkole : any = [];
	fakulteti : any = [];
	statusi : any = [];
	jedinice : any = [];
	razrediostali : any = [{id:'101', naziv : 'Drugi'}, {id:'102', naziv : 'Treći'}, {id:'103', naziv : 'Četvrti'}];
	razrediprvi : any = [{id:'9', naziv : 'Prvi'}];
	razredisvi : any = [{id:'9', naziv : 'Prvi'}, {id:'101', naziv : 'Drugi'}, {id:'102', naziv : 'Treći'}, {id:'103', naziv : 'Četvrti'}];
	
	razredi : any = [];
	takmicenjaBodovi : any = [{id:null, naziv : ''}, {id:'7', naziv : '7'}, {id:'5', naziv : '5'}, {id : '3', naziv : '3'}];
	bodoviDisciplina : any = [{id:null, naziv : ''}, {id:'3', naziv : '3'}, {id:'-5', naziv : '-5'}];
	luce : any = [{id:null, naziv : ''}, {id:'0', naziv : ''}, {id:'1', naziv : 'Luča A'}, {id : '2', naziv : 'Luča B'}];
	godine : any = [{id:'2', naziv : '2'}, {id:'3', naziv : '3'}, {id:'4', naziv : '4'}, {id:'5', naziv : '5'}, {id:'6', naziv : '6'}];
	godine_mas : any = [{id:'1', naziv : '1'}, {id:'2', naziv : '2'}];
	godine_sve : any = [{id:'1', naziv : '1'}, {id:'2', naziv : '2'}, {id:'3', naziv : '3'}, {id:'4', naziv : '4'}, {id:'5', naziv : '5'}, {id:'6', naziv : '6'}];
	nivoiStudija : any = [{id:null, naziv : ''}, {id:'O', naziv : 'Osnovne'}, {id:'M', naziv : 'Master'}];

	ngOnInit() {
		this.novi = this.id?false:true; 
		
		this.ucitaj();

		let elems = document.querySelectorAll('.tooltipped');
		let instances = M.Tooltip.init(elems, {});
	}

	getRazred(){
		if (this.prijavadom.idRazreda == '9') return 'Prvi';
		else if (this.prijavadom.idRazreda == '101') return 'Drugi';
		else if (this.prijavadom.idRazreda == '102') return 'Treći';
		else if (this.prijavadom.idRazreda == '103') return 'Četvrti';

		return;
	}

	getUstanova(){
		if (this.prijavadom.srednjeSkole && this.prijavadom.srednjeSkole.length > 0)
			return this.prijavadom.srednjeSkole[0].naziv;
	}

	nivoStudijaSelected(event){
		this.prijavadom.godina = null;
	}

	ucitaj() {
		this.loading = true;
		this.http.get('prijave/traziprijavudom', { params: { id: this.id, tipPrijave : this.idTipaPrijave } })
			.subscribe(data => {
				//console.log(data);
				this.loading = false;
				this.prijavadom = data;	
				
				this.kategorije = this.prijavadom.kategorije;
				this.takmicenja = this.prijavadom.takmicenja;
				this.opstine = this.prijavadom.opstine; 
				this.drzavljanstva = this.prijavadom.drzavljanstva;
				this.srednjeSkole = this.prijavadom.srednjeSkole;
				this.fakulteti = this.prijavadom.fakulteti; 
				this.statusi = this.prijavadom.statusi;
				this.jedinice = this.prijavadom.jedinice;
				
				setTimeout(() => {
					M.updateTextFields();
				}, 300);
				
				//this.ucitajSkole();	
				this.prijavadom.takmicenja = [];
				this.prijavadom.opstine = [];
				this.prijavadom.drzavljanstva = [];
				this.prijavadom.srednjeSkole = [];
				this.prijavadom.fakulteti = [];
				this.prijavadom.statusi = [];
				this.prijavadom.jedinice = [];

				if (this.novi){
					this.prijavadom.idTipaPrijave = this.idTipaPrijave; 
					if (this.idTipaPrijave == '1'){
						this.prijavadom.idRazreda = '9';
						this.prijavadom.nazivRazreda = 'Prvi';
						this.prijavadom.srOcjena8 = null;
						this.prijavadom.srOcjena9 = null;
					}

					if (this.idTipaPrijave == '2'){
						this.prijavadom.srOcjenaPrethodni = null;
					}
				}
				else {
					this.idTipaPrijave = this.prijavadom.idTipaPrijave; 
				}

				this.razredi = (this.idTipaPrijave == '1')?this.razrediprvi:this.razrediostali;

				
				setTimeout(() => {
					var elems = document.querySelector('#opstina');
					//console.log(elems);
    				var instances = M.Autocomplete.init(elems, {
						data: this.initAutoCompleteList(this.opstine),
						onAutocomplete: (txt) => {
							this.prijavadom.opstina = txt;
						},
					});
				}, 200)

				setTimeout(() => {
					var elems1 = document.querySelector('#drzava');
					//console.log(elems);
    				var instances1 = M.Autocomplete.init(elems1, {
						data: this.initAutoCompleteList(this.drzavljanstva),
						onAutocomplete: (txt) => {
							this.prijavadom.drzava = txt;
						},
					});
				}, 200)

				setTimeout(() => {
					var elems2 = document.querySelector('#drzavljanstvo');
					//console.log(elems);
    				var instances2 = M.Autocomplete.init(elems2, {
						data: this.initAutoCompleteList(this.drzavljanstva),
						onAutocomplete: (txt) => {
							this.prijavadom.drzavljanstvo = txt;
						},
					});
				}, 200)
			}
			, error => {
				this.loading = false;
			});
	}

	initAutoCompleteList(stavke){
		let obj = {};
		for(let i = 0; i < stavke.length; i++){
			obj[stavke[i].naziv] = null;
		}		
		return obj;
	}

	ucitajDomove = () => {
		this.loading = true;
		this.http.get('prijave/domovi', { params: { tip : this.prijavadom.idTipaPrijave} })
			.subscribe(data => {
				this.loading = false;
				this.domovi = data;

				setTimeout(() => {
					M.updateTextFields();
				}, 300);
			}
			, error => {
				this.loading = false;
			});
		
	}

	toastTimeout = 3000;

	savedata() {
		try {
			
			if (this.prijavadom.jmbg === undefined || this.prijavadom.jmbg == null || this.prijavadom.jmbg == '') {
				this.err_jmbg = true;
				this.err_jmbg_poruka = 'Morate definisati polje JMB.';
				M.toast({html: this.err_jmbg_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_jmbg = false;
			this.err_jmbg_poruka = '';

			if (this.prijavadom.ime === undefined || this.prijavadom.ime == null || this.prijavadom.ime == '') {
				this.err_ime = true;
				this.err_ime_poruka = 'Morate definisati polje Ime.';
				M.toast({html: this.err_ime_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_ime = false;
			this.err_ime_poruka = '';

			if (this.prijavadom.prezime === undefined || this.prijavadom.prezime == null || this.prijavadom.prezime == '') {
				this.err_prezime = true;
				this.err_prezime_poruka = 'Morate definisati polje Prezime.';
				M.toast({html: this.err_prezime_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_prezime = false;
			this.err_prezime_poruka = '';
			
			if (this.prijavadom.opstina === undefined || this.prijavadom.opstina == null || this.prijavadom.opstina == ''){
				this.err_opstina = true;
				this.err_opstina_poruka = 'Morate definisati polje Opština.';
				M.toast({html: this.err_opstina_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_opstina = false;
			this.err_opstina_poruka = '';

			if (!this.prijavadom.adresa) {
				this.err_adresa = true;
				this.err_adresa_poruka = 'Morate definisati polje Adresa.';
				M.toast({html: this.err_adresa_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_adresa = false;
			this.err_adresa_poruka = '';
			
			if (!this.prijavadom.drzava) {
				this.err_drzava = true;
				this.err_drzava_poruka = 'Morate definisati polje Država.';
				M.toast({html: this.err_drzava_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_drzava = false;
			this.err_drzava_poruka = '';

			if (!this.prijavadom.datumRodjenja) {
				this.err_datumRodjenja = true;
				this.err_datumRodjenja_poruka = 'Morate definisati polje Datum rođenja.';
				M.toast({html: this.err_datumRodjenja_poruka, displayLength : this.toastTimeout});
				return;
			}

			if (!this.CheckDate(this.prijavadom.datumRodjenja)) {
				this.err_datumRodjenja = true;
				this.err_datumRodjenja_poruka = 'Nevalidan format za Datum rođenja. Unesite datum u formatu dd.mm.gggg. Npr. 01.12.2001';
				M.toast({html: this.err_datumRodjenja_poruka, displayLength : this.toastTimeout});
				return;
			}

			this.err_datumRodjenja = false;
			this.err_datumRodjenja_poruka = '';

			if (!this.prijavadom.drzavljanstvo) {
				this.err_drzavljanstvo = true;
				this.err_drzavljanstvo_poruka = 'Morate definisati polje Državljanstvo.';
				M.toast({html: this.err_drzavljanstvo_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_drzavljanstvo = false;
			this.err_drzavljanstvo_poruka = '';

			/*if (!this.prijavadom.mjestoRodjenja){
				this.err_mjestoRodjenja = true;
				this.err_mjestoRodjenja_poruka = 'Morate definisati polje Mjesto rođenja.';
				M.toast({html: this.err_mjestoRodjenja_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_mjestoRodjenja = false;
			this.err_mjestoRodjenja_poruka = '';*/

			if (!this.prijavadom.pol) {
				this.err_pol = true;
				this.err_pol_poruka = 'Morate definisati polje Pol.';
				M.toast({html: this.err_pol_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_pol = false;
			this.err_pol_poruka = '';

			/*if (this.prijavadom.telefon === undefined || this.prijavadom.telefon == null || this.prijavadom.telefon == ''){
				this.err_telefon = true;
				this.err_telefon_poruka = 'Morate definisati polje Broj telefona';
				M.toast({html: this.err_telefon_poruka, displayLength : this.toastTimeout});
				return;
			}
			this.err_telefon = false;
			this.err_telefon_poruka = '';*/

			if (this.idTipaPrijave == '1' || this.idTipaPrijave == '2' || this.idTipaPrijave == '5'){				
				if (!this.prijavadom.idUstanove) {
					this.err_idUstanove = true;
					this.err_idUstanove_poruka = 'Morate definisati polje Srednja škola.';
					M.toast({html: this.err_idUstanove_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_idUstanove = false;
				this.err_idUstanove_poruka = '';

				if (!this.prijavadom.idRazreda) {
					this.err_idRazreda = true;
					this.err_idRazreda_poruka = 'Morate definisati polje Razred.';
					M.toast({html: this.err_idRazreda_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_idRazreda = false;
				this.err_idRazreda_poruka = '';
			}

			if (this.idTipaPrijave == '1'){
				if (!this.prijavadom.srOcjena8) {
					this.err_srocjena8 = true;
					this.err_srocjena8_poruka = 'Morate definisati polje Sr. ocjena VIII razred.';
					M.toast({html: this.err_srocjena8_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckNumber(this.prijavadom.srOcjena8)){
					this.err_srocjena8 = true;
					this.err_srocjena8_poruka = 'Nevalidan format za polje Sr. ocjena VIII razred. Zadajte broj na dvije decimale. Npr. 4.54';
					M.toast({html: this.err_srocjena8_poruka, displayLength : this.toastTimeout});
					return;
				}

				let floatVal = parseFloat(this.prijavadom.srOcjena8);
				if (floatVal < 2 || floatVal > 5){
					this.err_srocjena8 = true;
					this.err_srocjena8_poruka = 'Nevalidna vrijednost za polje Sr. ocjena VIII razred. Zadajte broj između 2 i 5.';
					M.toast({html: this.err_srocjena8_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_srocjena8 = false;
				this.err_srocjena8_poruka = '';

				if (!this.prijavadom.srOcjena9) {
					this.err_srocjena9 = true;
					this.err_srocjena9_poruka = 'Morate definisati polje Sr. ocjena IX razred.';
					M.toast({html: this.err_srocjena9_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckNumber(this.prijavadom.srOcjena9)){
					this.err_srocjena9 = true;
					this.err_srocjena9_poruka = 'Nevalidan format za polje Sr. ocjena IX razred. Zadajte broj na dvije decimale. Npr. 4.54';
					M.toast({html: this.err_srocjena9_poruka, displayLength : this.toastTimeout});
					return;
				}

				floatVal = parseFloat(this.prijavadom.srOcjena9);
				if (floatVal < 2 || floatVal > 5){
					this.err_srocjena9 = true;
					this.err_srocjena9_poruka = 'Nevalidna vrijednost za polje Sr. ocjena IX razred. Zadajte broj između 2 i 5.';
					M.toast({html: this.err_srocjena9_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_srocjena9 = false;
				this.err_srocjena9_poruka = '';
			}

			if (this.idTipaPrijave == '2'){
				if (!this.prijavadom.srOcjenaPrethodni) {
					this.err_srocjenapret = true;
					this.err_srocjenapret_poruka = 'Morate definisati polje Sr. ocjena.';
					M.toast({html: this.err_srocjenapret_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckNumber(this.prijavadom.srOcjenaPrethodni)){
					this.err_srocjenapret = true;
					this.err_srocjenapret_poruka = 'Nevalidan format za polje Sr. ocjena. Zadajte broj na dvije decimale. Npr. 4.54';
					M.toast({html: this.err_srocjenapret_poruka, displayLength : this.toastTimeout});
					return;
				}

				let floatVal = parseFloat(this.prijavadom.srOcjenaPrethodni);
				if (floatVal < 2 || floatVal > 5){
					this.err_srocjenapret = true;
					this.err_srocjenapret_poruka = 'Nevalidna vrijednost za polje Sr. ocjena. Zadajte broj između 2 i 5.';
					M.toast({html: this.err_srocjenapret_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_srocjenapret = false;
				this.err_srocjenapret_poruka = '';
			}

			if (this.idTipaPrijave == '3'){
				if (!this.prijavadom.srOcjenaPretPrethodni) {
					this.err_srocjenapretpret = true;
					this.err_srocjenapretpret_poruka = 'Morate definisati polje Sr. ocjena III raz.';
					M.toast({html: this.err_srocjenapretpret_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckNumber(this.prijavadom.srOcjenaPretPrethodni)){
					this.err_srocjenapretpret = true;
					this.err_srocjenapretpret_poruka = 'Nevalidan format za polje Sr. ocjena III raz. Zadajte broj na dvije decimale. Npr. 4.54';
					M.toast({html: this.err_srocjenapretpret_poruka, displayLength : this.toastTimeout});
					return;
				}

				let floatVal = parseFloat(this.prijavadom.srOcjenaPretPrethodni);
				if (floatVal < 2 || floatVal > 5){
					this.err_srocjenapretpret = true;
					this.err_srocjenapretpret_poruka = 'Nevalidna vrijednost za polje Sr. ocjena III raz. Zadajte broj između 2 i 5.';
					M.toast({html: this.err_srocjenapretpret_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_srocjenapretpret = false;
				this.err_srocjenapretpret_poruka = '';

				if (!this.prijavadom.srOcjenaPrethodni) {
					this.err_srocjenapret = true;
					this.err_srocjenapret_poruka = 'Morate definisati polje Sr. ocjena IV raz.';
					M.toast({html: this.err_srocjenapret_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckNumber(this.prijavadom.srOcjenaPrethodni)){
					this.err_srocjenapret = true;
					this.err_srocjenapret_poruka = 'Nevalidan format za polje Sr. ocjena IV raz. Zadajte broj na dvije decimale. Npr. 4.54';
					M.toast({html: this.err_srocjenapret_poruka, displayLength : this.toastTimeout});
					return;
				}

				floatVal = parseFloat(this.prijavadom.srOcjenaPrethodni);
				if (floatVal < 2 || floatVal > 5){
					this.err_srocjenapret = true;
					this.err_srocjenapret_poruka = 'Nevalidna vrijednost za polje Sr. ocjena IV raz. Zadajte broj između 2 i 5.';
					M.toast({html: this.err_srocjenapret_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_srocjenapret = false;
				this.err_srocjenapret_poruka = '';

				if (!this.prijavadom.ocjenaExt) {
					this.err_ocjenaext = true;
					this.err_ocjenaext_poruka = 'Morate definisati polje Ocjena na maturskom/stručnom ispitu.';
					M.toast({html: this.err_ocjenaext_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckNumber(this.prijavadom.ocjenaExt)){
					this.err_ocjenaext = true;
					this.err_ocjenaext_poruka = 'Nevalidan format za Ocjena na maturskom/stručnom ispitu. Zadajte broj na dvije decimale. Npr. 4.54';
					M.toast({html: this.err_ocjenaext_poruka, displayLength : this.toastTimeout});
					return;
				}

				floatVal = parseFloat(this.prijavadom.ocjenaExt);
				if (floatVal < 0 || floatVal > 5){
					this.err_ocjenaext = true;
					this.err_ocjenaext_poruka = 'Nevalidna vrijednost za polje Sr. ocjena IV raz. Zadajte broj između 0 i 5.';
					M.toast({html: this.err_ocjenaext_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_ocjenaext = false;
				this.err_ocjenaext_poruka = '';
			}

			if (this.idTipaPrijave == '3' || this.idTipaPrijave == '4' || this.idTipaPrijave == '6'){
				if (!this.prijavadom.idFakulteta) {
					this.err_idFakulteta = true;
					this.err_idFakulteta_poruka = 'Morate definisati polje Fakultet.';
					M.toast({html: this.err_idFakulteta_poruka, displayLength : this.toastTimeout});
					return;
				}

				this.err_idFakulteta = false;
				this.err_idFakulteta_poruka = '';

				if (this.idTipaPrijave == '3'){
					this.prijavadom.godina = '1';
					this.prijavadom.nivoiStudija = 'O';
				}
				else {
					if (!this.prijavadom.nivoStudija) {
						this.err_nivoStudija = true;
						this.err_nivoStudija_poruka = 'Morate definisati polje Nivo studija.';
						M.toast({html: this.err_nivoStudija_poruka, displayLength : this.toastTimeout});
						return;
					}
	
					this.err_nivoStudija = false;
					this.err_nivoStudija_poruka = '';

					if (!this.prijavadom.godina) {
						this.err_godina = true;
						this.err_godina_poruka = 'Morate definisati polje Godina.';
						M.toast({html: this.err_godina_poruka, displayLength : this.toastTimeout});
						return;
					}
				}

				this.err_godina = false;
				this.err_godina_poruka = '';
			}

			if (this.idTipaPrijave == '4'){
				if (!this.prijavadom.indexUspjesnosti) {
					this.err_indexUspjesnosti = true;
					this.err_indexUspjesnosti_poruka = 'Morate definisati polje Indeks uspjeha ostvaren u prethodnoj studijskoj godini.';
					M.toast({html: this.err_indexUspjesnosti_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckNumber(this.prijavadom.indexUspjesnosti)){
					this.err_indexUspjesnosti = true;
					this.err_indexUspjesnosti_poruka = 'Nevalidan format za polje Indeks uspjeha ostvaren u prethodnoj studijskoj godini. Zadajte broj na najviše dvije decimale. ';
					M.toast({html: this.err_indexUspjesnosti_poruka, displayLength : this.toastTimeout});
					return;
				}

				this.err_indexUspjesnosti = false;
				this.err_indexUspjesnosti_poruka = '';

				if (!this.prijavadom.brojETCS) {
					this.err_brojETCS = true;
					this.err_brojETCS_poruka = 'Morate definisati polje Broj osvarenih ETCS kredita.';
					M.toast({html: this.err_brojETCS_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckNumber(this.prijavadom.brojETCS)){
					this.err_brojETCS = true;
					this.err_brojETCS_poruka = 'Nevalidan format za polje Broj osvarenih ETCS kredita. Zadajte broj na najviše dvije decimale. ';
					M.toast({html: this.err_indexUspjesnosti_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_brojETCS = false;
				this.err_brojETCS_poruka = '';

				


				if (!this.prijavadom.redniBrojUpisaGod) {
					this.err_redniBrojUpisaGod = true;
					this.err_redniBrojUpisaGod_poruka = 'Morate definisati polje Redni broj upisa stud. godine.';
					M.toast({html: this.err_redniBrojUpisaGod_poruka, displayLength : this.toastTimeout});
					return;
				}

				if (!this.globalSrvc.CheckInt(this.prijavadom.redniBrojUpisaGod)){
					this.err_redniBrojUpisaGod = true;
					this.err_redniBrojUpisaGod_poruka = 'Nevalidan format za polje Redni broj upisa stud. godine. Zadajte cjelobrojnu vrijednost.';
					M.toast({html: this.err_indexUspjesnosti_poruka, displayLength : this.toastTimeout});
					return;
				}
				this.err_redniBrojUpisaGod = false;
				this.err_redniBrojUpisaGod_poruka = '';
			}
			let url = 'prijave/domovi/izmijeni';
			if (!this.prijavadom.id){
				url = 'prijave/dodajprijavudjackidom';
			}
			this.loading = true;
			
			setTimeout(() => {				
			
				this.http.post(url, this.prijavadom)
					.subscribe(data => {
						this.msg = data;
						this.loading = false;

						if (this.msg.id == 1) {
							if (this.prijavadom.id === undefined || this.prijavadom.id == null || this.prijavadom.id == '') {
								this.prijavadom.id = this.msg.newId;
							}
							//this.activeModal.close(this.prijavaskola);
							//this.globalSrvc.showSuccessModal();
							//M.toast({html : 'Uspješno', displayLength : this.toastTimeout});

							if (this.onInsertDom)
								this.onInsertDom.emit(this.prijavadom);
						}
						else {
							//this.globalSrvc.showErrorModal(this.msg.text);
							M.toast({html:this.msg.text, displayLength : this.toastTimeout});
						}
					}
					, error => {
						this.loading = false;
						//this.globalSrvc.showGenericErrorModal();
					}
				);
			}, 1000);			
		}
		catch (err) {

		}
	}
	crps_data: any = null;

	centralniregistar() {
		this.loading = true;

		setTimeout(() => {			
		
			this.http.get(this.globalSrvc.rootUrl + 'prijave/domovi/djacki/registri/pretraga/jmbg/', { params: { jmbg: this.prijavadom.jmbg, tip:this.prijavadom.idTipaPrijave} })
				.subscribe(data => {
					this.loading = false;			
					this.crps_data = data;
					
					if (this.crps_data && this.crps_data.errMsg){
						this.err_jmbg = true;
						this.err_jmbg_poruka = this.crps_data.errMsg + '!';
						M.toast({html: this.crps_data.errMsg + '!', displayLength : 4000});
						return;
					}
					
					if (this.crps_data.ime != null && this.crps_data.ime != '') {						
						this.prijavadom.ime = this.crps_data.ime;
						this.prijavadom.prezime = this.crps_data.prezime;
						this.prijavadom.imeOca = this.crps_data.imeOca;
						this.prijavadom.imeMajke = this.crps_data.imeMajke;
						this.prijavadom.adresa = this.crps_data.adresa;
						this.prijavadom.opstina = this.crps_data.opstina;
						this.prijavadom.drzavljanstvo = this.crps_data.drzavljanstvo;
						this.prijavadom.drzava = this.crps_data.drzava;

						if (!(this.crps_data.datumRodjenja === undefined) && this.crps_data.datumRodjenja != null && this.crps_data.datumRodjenja != '')
							this.prijavadom.datumRodjenja = this.crps_data.datumRodjenja;
						
						this.prijavadom.mjestoRodjenja = this.crps_data.mjestoRodjenja;
						this.prijavadom.opstinaRodjenja = this.crps_data.opstinaRodjenja;
						this.prijavadom.drzavaRodjenja = this.crps_data.drzavaRodjenja;
						this.prijavadom.mjestoPrebivalista = this.crps_data.mjestoPrebivalistaPunNaziv;
						this.prijavadom.pol = this.crps_data.pol;
						
						setTimeout(() => {
							M.updateTextFields();
						}, 100);

						this.err_jmbg = false;
						this.err_jmbg_poruka = '';
					}
					else {
						this.err_jmbg = true;
						this.err_jmbg_poruka = 'U registrima nije nađen zadati JMB!';
						M.toast({html:  'U registrima nije nađen zadati JMB!', displayLength : 4000});

						this.prijavadom.ime = '';
						this.prijavadom.prezime = '';
						this.prijavadom.imeOca = '';
						this.prijavadom.imeMajke = '';
						this.prijavadom.adresa = '';
						this.prijavadom.datumRodjenja = '';					
						this.prijavadom.mjestoRodjenja = '';
						this.prijavadom.opstinaRodjenja = '';
						this.prijavadom.drzavaRodjenja = '';
						this.prijavadom.mjestoPrebivalista = '';
						this.prijavadom.pol = '';
						this.prijavadom.drzavljanstvo = '';
						this.prijavadom.opstina = '';
						this.prijavadom.drzava = '';
						return;
					}
				}
				, error => {
					this.loading = false;
				}
			);
		}, 500);
		/**/ 
	}

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	jmbgChanged(){
		/*this.prijavadom.ime = '';
		this.prijavadom.prezime = '';
		this.prijavadom.imeOca = '';
		this.prijavadom.imeMajke = '';
		this.prijavadom.adresa = '';
		this.prijavadom.datumRodjenja = '';					
		this.prijavadom.mjestoRodjenja = '';
		this.prijavadom.opstinaRodjenja = '';
		this.prijavadom.drzavaRodjenja = '';
		this.prijavadom.mjestoPrebivalista = '';
		this.prijavadom.pol = '';
		this.prijavadom.drzavljanstvo = '';
		this.prijavadom.opstina = '';

		setTimeout(() => {
			M.updateTextFields();
		}, 100);*/
	}

	jmbgfocuslost(event){
		if (this.prekoPortala == '1')
			return; 

		if (!this.prijavadom.jmbg || this.prijavadom.jmbg.length <= 7)
			return; 

		let danStr = this.prijavadom.jmbg.substring(0, 2);
		let mjesecStr = this.prijavadom.jmbg.substring(2, 4);
		let godinaStr = this.prijavadom.jmbg.substring(4, 7);

		let dan = parseInt(danStr, 10);
        if (!Number.isInteger(dan)){
            return;
        }

		let mjesec = parseInt(mjesecStr, 10);
        if (!Number.isInteger(mjesec)){
            return;
        }

		let prefix = '2';
		let godina = parseInt('2' + godinaStr, 10);
        if (!Number.isInteger(godina)){
            return;
        }
		
		if (godina > (new Date()).getFullYear()){
			godina = parseInt('1' + godinaStr, 10);
			prefix = '1';
		}
		let datum = danStr + '.' + mjesecStr + '.' + prefix + '' + godinaStr;

		if (this.CheckDate(datum)){
			this.prijavadom.datumRodjenja = datum;
			
			setTimeout(() => {
				M.updateTextFields();
			}, 100);
		}
	}

	CheckDate(dateString)
	{
		// First check for the pattern
		if(!/^\d{2}\.\d{2}\.\d{4}$/.test(dateString))
			return false;

		// Parse the date parts to integers
		var parts = dateString.split(".");
		var day = parseInt(parts[0], 10);
		var month = parseInt(parts[1], 10);
		var year = parseInt(parts[2], 10);

		// Check the ranges of month and year
		if(year < 1000 || year > 3000 || month == 0 || month > 12)
			return false;

		var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

		// Adjust for leap years
		if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
			monthLength[1] = 29;

		// Check the range of the day
		return day > 0 && day <= monthLength[month - 1];
	};
}
